import { sendData, getData } from './../../misc/server.js';
export default {
    state: {

        data:null,
        loading: false,
        

    },
    mutations:
    {

        SET_DATA(state, payload) {
            state.data = payload;
        },
        SET_LOADING(state, payload) {
            state.loading = payload;
        },
    },
    actions: {


        async get_your_exam({ commit }) {
            var url = "yourexam/get?";

         
            url += "&";
            
            commit('SET_LOADING', true);
            var response = await getData(url);

            commit("SET_DATA", response);
            commit('SET_LOADING', false);

        },
       
        



    },
    getters: {


        your_exams(state) {
            return state.data;
        },
        your_exam_loading(state) {
            return state.loading;
        },
    
       

    }
}